export type SiteDisclaimer = {
  id: 'general' | 'reminder' | 'symptom';
  title: string;
  body: string;
  emphasisTitle?: string;
  emphasis: string;
};

export const siteDisclaimers: SiteDisclaimer[] = [
  {
    id: 'general',
    title: 'About this app',
    body: 'This app gives general information. It does not diagnose, treat or give medical recommendations. It is not a substitute for assessment by a qualified clinician.',
    emphasisTitle: 'Seek urgent care immediately if you have:',
    emphasis: "vision loss, pain or a red eye that's getting worse.",
  },
  {
    id: 'reminder',
    title: 'Treatment reminders',
    body: 'This reminder is a support tool. Follow the frequency your eye care specialist recommended.',
    emphasis: 'Notifications can fail and are not for urgent medication.',
  },
  {
    id: 'symptom',
    title: 'Symptom log',
    body: 'This log helps you track your own symptoms over time — it should not be used to monitor improvement or deterioration of condition.',
    emphasisTitle: 'Seek urgent care immediately if you have:',
    emphasis: "vision loss, pain or a red eye that's getting worse.",
  },
];
